import SearchForm from '../../components/searchForm/searchForm'
import './landingPage.css'

export default function LandingPage() {
  return (
    <>
      <div className="background-image">
        <SearchForm />
      </div>
    </>
  )
}
